// extracted by mini-css-extract-plugin
export default {"StrollerDetailRating":"xi_a bhe_a bhe_x","StrollerDetailRating__muted":"xi_b bhe_fm"};